import {
  client,
  SitesControllerListSummariesData,
  SiteSummaryDto,
} from "@/client";
import { isDefined } from "@/lib/utils";
import { createTableContext } from "@/components/custom/data-table/data-table-context";
import {
  formatSiteIdsChip,
  formatSiteTagIdsChip,
} from "@/components/custom/data-table/filter-chip-lookups";
import { useColumns } from "./-sites-columns";
import { OpenAPI } from "@/client";

export const SitesTableContext = createTableContext<
  SiteSummaryDto,
  SitesControllerListSummariesData
>({
  queryArgument: () => ({ page: 1, limit: 10 }),
  getRowId: (row) => {
    if (isDefined(row?.id)) {
      return `${row.id}`;
    }
    console.warn("undefined row.id", row);
    return ``;
  },
  queryCreator: (params) => client.sites.listSummaries.asQueryOptions(params),
  columns: useColumns,
  searchField: "name",
  searchLabel: "Site Name",
  defaultFilters: {
    siteIds: undefined,
    tagIds: undefined,
  },
  filterBreadcrumbs: {
    formatters: {
      siteIds: formatSiteIdsChip,
      tagIds: formatSiteTagIdsChip,
    },
  },

  downloadCsv: {
    url: () => `${OpenAPI.BASE}/api/v2/dashboard/sites/download`,
    fileName: "sites",
    permission: (permissions) => permissions.sites.download,
  },
});
